import { CollisionDetection, pointerWithin } from '@dnd-kit/core'

/**
 * Кастомный алгоритм определения коллизий.
 * Всегда приоритизирует зоны вставки строк (row-insert) перед остальными droppable.
 * Это гарантирует, что когда указатель находится на полосе между строками,
 * виджет встаёт в новую строку, а не в существующую.
 */
export const rowInsertFirstCollision: CollisionDetection = args => {
	// Сначала проверяем только row-insert зоны
	const rowInsertContainers = args.droppableContainers.filter(
		c => c.data?.current?.type === 'row-insert',
	)

	if (rowInsertContainers.length > 0) {
		const insertCollisions = pointerWithin({
			...args,
			droppableContainers: rowInsertContainers,
		})
		if (insertCollisions.length > 0) return insertCollisions
	}

	// Затем обычные row и widget зоны (исключаем dashboard-dropzone как самый большой)
	const rowAndWidgetContainers = args.droppableContainers.filter(
		c => c.id !== 'dashboard-dropzone',
	)

	if (rowAndWidgetContainers.length > 0) {
		const rowCollisions = pointerWithin({
			...args,
			droppableContainers: rowAndWidgetContainers,
		})
		if (rowCollisions.length > 0) return rowCollisions
	}

	// Fallback на dashboard-dropzone
	return pointerWithin(args)
}
